/**
 * Scroll to the active menu item.
 *
 * @param {string} activeItemClass Active Item Class.
 * @param {Element} scrollContainer Current Scroll Container.
 */
export const scrollToActiveItem = ( activeItemClass, scrollContainer ) => {
	const activeItem = document.querySelector( activeItemClass );
	if ( ! activeItem ) {
		return;
	}

	const activeItemRect = activeItem.getBoundingClientRect();

	// Calculate the desired scroll position
	const activeItemMiddle = activeItemRect.left + activeItemRect.width / 2;
	const halfWindowWidth = window.innerWidth / 2;
	let scrollByLeft = activeItemMiddle - halfWindowWidth;

	// Prevent scrolling past the start (left edge)
	const currentScroll = scrollContainer.scrollLeft;
	const minScroll = 0;

	// Ensure we don't scroll past the start
	if ( currentScroll + scrollByLeft < minScroll ) {
		scrollByLeft = -currentScroll; // Scroll back to the start
	}

	scrollContainer.scrollBy( {
		left: scrollByLeft,
		behavior: 'smooth',
	} );
};
